import { CASE_TYPE } from '@demandproai/shared';
import { handleEnterKeyPress } from '../../../../utils/handleEnterKey';
import CaseLiabilityReports from '../../../../components/common/CaseLiabilityReports';
import CaseLiabilityTextFields from '../../../../components/common/CaseLiabilityTextFields';
import CaseAccidentScene from '../../../../components/common/CaseAccidentScene';
import XCheckbox from '../../../../components/common/XCheckbox';
import RenderIf from '../../../../components/render-if/Renderif';
import useLiabilityAnalysisForm from '../../../../hooks/useLiabilityAnalysisForm';
import useSilentWitnessFeatureFlag from '../../../../hooks/useSilentWitnessFeatureFlag';
import SilentWitness from '../../../../components/common/SilentWitness';
import { formBackgroundClasses, formItemPdClasses } from '../../../../components/common/formClasses';
import { useAddCaseFormContext } from '../../../../contexts/AddCaseFormContext';

const headerRowClasses = 'flex justify-between items-center w-full mr-4 mb-4';

const LiabilityAnalysisForm = () => {
  const { defendants, toggleSingleLiabilityMode, isSingleLiabilityMode } = useLiabilityAnalysisForm();
  const { formik } = useAddCaseFormContext();
  const caseType = formik.values.caseInfo?.caseType;
  const isSilentWitnessUiEnabled = useSilentWitnessFeatureFlag();

  return (
    <form onKeyDown={(e) => handleEnterKeyPress(e)}>
      <div className="p-0!">
        <div className={`accordion ${formBackgroundClasses} ${formItemPdClasses}`} id="accordionExample">
          <div className={headerRowClasses}>
            <h2>Reports & Statements</h2>
          </div>

          {defendants.length > 1 && (
            <div className="form-group">
              <XCheckbox
                label="Process all defendants in single liability section"
                name='caseInfo.isSingleLiabilitySectionForAllDefendants'
                onChange={toggleSingleLiabilityMode}
                checked={isSingleLiabilityMode}
              />
            </div>
          )}

          <CaseLiabilityTextFields />

          <CaseLiabilityReports />

          <RenderIf shouldRender={caseType === CASE_TYPE.AUTO_ACCIDENT && isSilentWitnessUiEnabled}>
            <SilentWitness />
          </RenderIf>

          <CaseAccidentScene />
        </div>
      </div>
    </form>
  );
};

export default LiabilityAnalysisForm;
